/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const putApiMacroprojectsIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const putApiMacroprojectsId200Schema = z.any();

export const putApiMacroprojectsIdMutationRequestSchema = z.object({
  name: z.coerce.string().min(1).max(500),
  client: z.object({
    value: z.coerce.number().int(),
    label: z.coerce.string(),
  }),
  isVisible: z.boolean(),
  costCenter: z
    .object({
      value: z.coerce.number().int(),
      label: z.coerce.string(),
    })
    .nullable(),
});

export const putApiMacroprojectsIdMutationResponseSchema = z.lazy(
  () => putApiMacroprojectsId200Schema,
);
